import React, { Component } from 'react';
import { Col, Row} from 'react-bootstrap';
import AdminLayout from './AdminLayout';
import AdminPrivateEventList from '../components/admin/AdminPrivateEventList';
import '../css/style.css';
import '../components/Home.css';

class AdminPrivateEventLayout extends Component {

    render(){
        return (
            <AdminLayout eventKey="3">
                <Row>
                    <Col >
                    <AdminPrivateEventList  eventType={'PRIVATE'}/>
                    </Col>
                </Row>
            </AdminLayout>              
        );
    }

}

export default AdminPrivateEventLayout;